// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1itez","right":"Footer_right__13n7l","buttons":"Footer_buttons__L_XrG"};